import {put, takeEvery} from 'redux-saga/effects';
import LightboxActions from "../actions";
import FileActions from 'bukku/redux/File/actions';

const {
    readFile,
} = FileActions;

export default function* onCurrentIndexChange(action) {
    const { readFileData, fileUrl, shouldReadFileId } = action;

    // Reading file (from File Manager)
    yield put(LightboxActions.setFiles([]));

    if (!shouldReadFileId) {
        if (readFileData && readFileData.file.url && readFileData.id) {
            yield put(LightboxActions.setFiles([readFileData]));
        }

        else if (fileUrl) {
            // when only has url (eg: initial Product Image / Signature Image)
            yield put(LightboxActions.setFiles([{
                file: {
                    url: fileUrl,
                    filename: null,
                },
                id: null,
                file_id: null,
                created_at: null,
                is_shared: false,
                hasError: false,
            }]));
        }
    }

    else {
        yield put(readFile(shouldReadFileId));

        // Wait for Success/Error
        yield takeEvery(
            [
                FileActions.FILE_READ_FILE_SUCCESS,
                FileActions.FILE_READ_FILE_ERROR,
            ],
            function* (action) {
                let updatedFile = {...action.file};
                // Success
                if (action.type === FileActions.FILE_READ_FILE_SUCCESS) {
                    updatedFile = {
                        file: updatedFile,
                        id: updatedFile.id,
                        file_id: updatedFile.id,
                        created_at: updatedFile.created_at,
                        is_shared: false,
                        hasError: false,
                    };
                }
                // Error
                else if (action.type === FileActions.FILE_READ_FILE_ERROR) {
                    updatedFile = {
                        file: updatedFile,
                        id: updatedFile.id,
                        file_id: updatedFile.id,
                        created_at: null,
                        hasError: true,
                    };
                }

                yield put(LightboxActions.setFiles([updatedFile]));
            });
    }

    return null;
}
